<pdq-radio-group [formControl]="typeControl">
  <pdq-radio-button
    [value]="SubscriptionSelectorType.DEFAULT_SELECTOR"
    [checked]="typeControl.value === SubscriptionSelectorType.DEFAULT_SELECTOR"
    text="Default Selector"></pdq-radio-button>
  <pdq-radio-button
    [value]="SubscriptionSelectorType.UPGRADE"
    [checked]="typeControl.value === SubscriptionSelectorType.UPGRADE"
    text="Upgrade"
    [tooltip]="upgradeTooltip"></pdq-radio-button>
</pdq-radio-group>
@if (typeControl.value === SubscriptionSelectorType.UPGRADE) {
  <div class="nested-input">
    <pdq-input
      label="Upgrade Button Label"
      [formControl]="upgradeButtonLabelControl"
      [invalid]="upgradeButtonLabelInvalid"
      invalidMsg="Upgrade Button Label is required"></pdq-input>
    <span class="description"
      >The dynamic field &#123;subscription_group&#125; will be replaced with the first subscription group available for
      the product</span
    >
    <div class="button-controls-row">
      <pdq-dropdown
        title="Button Background"
        [formControl]="upgradeButtonAppearanceControl"
        [defaultOption]="upgradeButtonAppearanceControl.value | primitiveDropdownOptionPipe: appearanceToDisplayText"
        [options]="UpgradeAppearances | primitiveDropdownOptionsPipe: appearanceToDisplayText"
        [useOverlay]="true"
        [overlayPositions]="upwardOverlayPositions"></pdq-dropdown>
      @if (upgradeButtonAppearanceControl.value === TRANSPARENT_APPEARANCE) {
        <pdq-dropdown
          title="Button Text Color"
          [formControl]="upgradeButtonTextColorControl"
          [defaultOption]="upgradeButtonTextColorControl.value | primitiveDropdownOptionPipe: appearanceToDisplayText"
          [options]="TextColorAppearances | primitiveDropdownOptionsPipe: appearanceToDisplayText"
          [useOverlay]="true"
          [overlayPositions]="upwardOverlayPositions"></pdq-dropdown>
      }
    </div>
  </div>
}
